import axiosInstance from "../axiosInstance";

/**
 * -------------------------------------------------------
 * INITIATE PAYMENT
 * -------------------------------------------------------
 * - Creates Cashfree order
 * - Returns paymentSessionId & orderId
 */
export const initiatePayment = async (applicationId, gateway) => {
  if (!applicationId) {
    throw new Error("applicationId is required");
  }

  const res = await axiosInstance.post("/payments/initiate", {
    applicationId,
    gateway,
  });

  return res.data;
};

/**
 * -------------------------------------------------------
 * VERIFY PAYMENT (SOURCE OF TRUTH)
 * -------------------------------------------------------
 * - Called after Cashfree redirect
 * - Safe to retry on refresh
 */
export const verifyPayment = async (orderId, body = null) => {
  if (!orderId) {
    throw new Error("orderId is required");
  }

  if (body) {
    const res = await axiosInstance.post(`/payments/verify/${orderId}`, body);
    return res.data;
  }

  const res = await axiosInstance.get(`/payments/verify/${orderId}`);
  return res.data;
};

/**
 * -------------------------------------------------------
 * GET PAYMENT STATUS (OPTIONAL POLLING)
 * -------------------------------------------------------
 * - Used for page refresh or background polling
 */
export const getPaymentStatus = async (orderId) => {
  if (!orderId) {
    throw new Error("orderId is required");
  }

  const res = await axiosInstance.get(`/payments/status/${orderId}`);
  return res.data;
};
